import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const questions = [
  {
    icon: 'ri-scan-2-line',
    text: '지반계측 / 스마트 계측이 궁금하신가요?',
  },
  {
    icon: 'ri-file-list-3-line',
    text: '프로젝트 견적이 필요하신가요?',
  },
  {
    icon: 'ri-brain-line',
    text: 'AI 기반 분석은 어떻게 진행되나요?',
  },
  {
    icon: 'ri-settings-4-line',
    text: '업무 자동화 및 AI 활용 방식이 궁금하신가요?',
  },
  {
    icon: 'ri-map-pin-2-line',
    text: '현장 적용 및 사례가 궁금하신가요?',
  },
];

const SolutionCTA = () => {
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-1 bg-[#E8521A] rounded-full" />
            <span className="text-[#E8521A] text-sm font-bold tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact
            </span>
            <span className="w-10 h-1 bg-[#E8521A] rounded-full" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-black text-[#1B2A4A] mb-4"
            style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}
          >
            궁금하신 내용을 선택해 주세요
          </h2>
          <p
            className="text-[#1B2A4A]/55 text-lg font-medium"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            선택하신 내용을 바탕으로 전문가가 맞춤 답변을 드립니다
          </p>
        </div>

        {/* Question Cards */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12 transition-all duration-700 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {questions.map((q, index) => (
            <button
              key={q.text}
              onClick={() => setSelected(selected === index ? null : index)}
              className={`group flex items-center gap-6 p-8 rounded-2xl border-2 text-left cursor-pointer transition-all duration-200 whitespace-normal ${
                selected === index
                  ? 'bg-[#1B2A4A] border-[#1B2A4A]'
                  : 'bg-white border-gray-100 hover:border-[#E8521A]/40 hover:bg-white'
              } ${index === 4 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div
                className={`w-16 h-16 flex items-center justify-center rounded-xl shrink-0 transition-all duration-200 ${
                  selected === index ? 'bg-[#E8521A]' : 'bg-[#E8521A]/10 group-hover:bg-[#E8521A]/20'
                }`}
              >
                <i
                  className={`${q.icon} text-3xl transition-colors duration-200 ${
                    selected === index ? 'text-white' : 'text-[#E8521A]'
                  }`}
                />
              </div>
              <div className="flex-1">
                <p
                  className={`text-[19px] font-bold leading-snug transition-colors duration-200 ${
                    selected === index ? 'text-white' : 'text-[#1B2A4A]'
                  }`}
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  {q.text}
                </p>
                {selected === index && (
                  <div className="flex items-center gap-1.5 mt-2">
                    <i className="ri-check-line text-[#E8521A] text-sm" />
                    <span className="text-white/60 text-sm" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>선택됨</span>
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div
          className={`flex justify-center transition-all duration-700 delay-500 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 bg-[#E8521A] text-white font-bold text-lg px-12 py-5 rounded-full hover:bg-[#d04515] transition-all duration-200 whitespace-nowrap"
          >
            견적 의뢰하기
            <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionCTA;
